module.exports = __webpack_public_path__ + "assets/img/BP-1.055f6d30.jpg";